export const themeJson = {
  backgroundImage: "",
  backgroundImageFit: "cover",
  backgroundImageAttachment: "scroll",
  backgroundOpacity: 1,
  themeName: "default",
  colorPalette: "light",
  isPanelless: true,
  cssVariables: {
    "--sjs-general-backcolor": "rgba(255, 255, 255, 1)",
    "--sjs-general-backcolor-dark": "rgba(248, 248, 248, 1)",
    "--sjs-general-backcolor-dim": "rgba(255, 255, 255, 1)",
    "--sjs-general-backcolor-dim-light": "rgba(249, 249, 249, 1)",
    "--sjs-general-backcolor-dim-dark": "rgba(243, 243, 243, 1)",
    "--sjs-general-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-forecolor-light": "rgba(0, 0, 0, 0.45)",
    "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",
    "--sjs-primary-backcolor": "#0F5F7E",
    "--sjs-primary-backcolor-light": "rgba(NaN, NaN, NaN, 0.1)",
    "--sjs-primary-backcolor-dark": "rgba(NaN, NaN, NaN, 1)",
    "--sjs-primary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-base-unit": "8px",
    "--sjs-corner-radius": "4px",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-shadow-small": "0px 1px 2px 0px rgba(0, 0, 0, 0.15)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.15)",
    "--sjs-shadow-medium": "0px 2px 6px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-large": "0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-inner": "inset 0px 1px 2px 0px rgba(0, 0, 0, 0.15)",
    "--sjs-shadow-inner-reset": "inset 0px 0px 0px 0px rgba(0, 0, 0, 0.15)",
    "--sjs-border-light": "rgba(0, 0, 0, 0.09)",
    "--sjs-border-default": "rgba(0, 0, 0, 0.16)",
    "--sjs-border-inside": "rgba(0, 0, 0, 0.16)",
    "--sjs-special-red": "rgba(229, 10, 62, 1)",
    "--sjs-special-red-light": "rgba(229, 10, 62, 0.1)",
    "--sjs-special-red-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-special-green": "rgba(25, 179, 148, 1)",
    "--sjs-special-green-light": "rgba(25, 179, 148, 0.1)",
    "--sjs-special-green-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-special-blue": "rgba(67, 127, 217, 1)",
    "--sjs-special-blue-light": "rgba(67, 127, 217, 0.1)",
    "--sjs-special-blue-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-special-yellow": "rgba(255, 152, 20, 1)",
    "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-special-yellow-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
  },
  header: {
    height: 256,
    inheritWidthFrom: "container",
    textAreaWidth: 512,
    overlapEnabled: false,
    backgroundImageOpacity: 1,
    backgroundImageFit: "cover",
    logoPositionX: "right",
    logoPositionY: "top",
    titlePositionX: "left",
    titlePositionY: "bottom",
    descriptionPositionX: "left",
    descriptionPositionY: "bottom",
  },
  headerView: "basic",
};

export const parentJson = {
  title: "Parent/Guardian Survey",
  logo: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MzUuMjggMTUxLjg3Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzcwYTU1Mzt9LmNscy0ye2ZpbGw6I2ZmZjt9LmNscy0ze2ZpbGw6I2Y2ODUyMTt9LmNscy00e2ZpbGw6IzFlOWViMDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmhvcGVfbG9nbzwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMy42Nyw4OC44OGE5MS43Miw5MS43MiwwLDAsMC0zLjg2LDEzLjMzcS4xMSwzLjM1LjI2LDYuNTJhOTUuNDMsOTUuNDMsMCwwLDAsMTMuMzQtLjM4bC4zMy0xLjVxLjgyLTQuNzcsMS42MS05LjQ1cy4yNS0xLjgzLjgtNC43NmMuNTYtMy4zMywxLjEyLTYuNjMsMS42OC05Ljg2LDAsMCw0LjU0LTE3LjkxLDEwLjgxLTIzLjc5LTE1LjUzLDQuODUtMjIuNDIsMjMuMTQtMjUsMjkuODkiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zMiwxMTUuMjJhODEuMTQsODEuMTQsMCwwLDEtMTEuNjUtMS41M2MuMTgsMy41NS4zNiw2Ljk0LjQ3LDEwLjEzbC0zLjkzLjE1QTEwLjE1LDEwLjE1LDAsMCwxLDYuMzIsMTEzLjdjMC0xLjM1LDAtMi43NC4wOS00LjE2LTIuNTEtMS00LjY2LTItNi40MS0yLjg0djQ1LjE3SDIyLjUxYzQuMjktMTIuMTYsNy4wNi0yNS4yOCw5LjQ1LTM2LjY1Ii8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNjguMTEsMjcuMjZhOC45MSw4LjkxLDAsMCwwLDIuMS0xLjgyQzc0LjMzLDIwLjU0LDczLDE0LjE3LDcyLjQ5LDEzLDcxLjQsMTAuNDMsNjksOS43Myw2Ni41OCwxMS4wOCw2Mi4zNywxMy40NSw2MCwyMSw2MiwyNS4zN2MxLjIyLDIuNjEsMy42NSwzLjM5LDYuMTEsMS44OSIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTQxLjU2LDBBMjc1LjQzLDI3NS40MywwLDAsMCwyNCw1MS44NCwxNjIuMDcsMTYyLjA3LDAsMCwwLDIxLDY5LjFjNS42OS04LjE3LDEzLjU1LTE1Ljc2LDIzLjkxLTE4LjMxLDguMzMtMi4wNiwyMy42Mi0yLjA4LDMwLjM2LDguNjEsNC4xMSw2LjUyLDMuMTksMTQuMSwxLjcsMTkuMzFhLjM4LjM4LDAsMCwxLS43NC0uMTZjLjczLTUuODEtLjc0LTExLjQxLTQuMy0xNS4zOEExNi42NSwxNi42NSwwLDAsMCw2Mi4zOCw1OGEyMSwyMSwwLDAsMC0yLjY3LDIuNzNBMjguMTgsMjguMTgsMCwwLDAsNTcsNjQuNjFjLS4yNy40Ny0uNTMsMS0uNzksMS40NkE0NC4xOSw0NC4xOSwwLDAsMCw1Myw3NC40OGMtLjM0LDEuMjQtLjY1LDIuNTItLjkyLDMuODQtLjEyLjQxLS4yNC44NC0uMzYsMS4yOC0uMjMuODctLjQ3LDEuNzctLjcxLDIuN2wtLjM2LDEuNGMtLjI0LDEtLjQ4LDEuOTMtLjcyLDIuOTItLjEyLjUtLjIzLDEtLjM1LDEuNTEtLjM2LDEuNTItLjcxLDMuMDctMS4wNiw0LjY1LS43LDMuMTUtMS4zOCw2LjQtMiw5LjYxLS4yNiwxLjMxLS41MiwyLjYyLS43OCwzLjkxLDIuMy0uNTQsNC42My0xLjE4LDctMS45NEE5NC4zOSw5NC4zOSwwLDAsMCw4Mi44MSw4OC4yM1YwWk03MC4yMSwyNS40NGE4LjkxLDguOTEsMCwwLDEtMi4xLDEuODJjLTIuNDYsMS41LTQuODkuNzItNi4xMS0xLjg5LTItNC4zOC4zNy0xMS45Miw0LjU3LTE0LjI5QzY5LDkuNzMsNzEuNCwxMC40Myw3Mi40OSwxM2MuNTMsMS4yMiwxLjg0LDcuNTktMi4yOCwxMi40OSIvPjxwYXRoIGNsYXNzPSJjbHMtNCIgZD0iTTUyLDExMy43NEE3NS43NSw3NS43NSwwLDAsMSw0NC4xMSwxMTVjLS42OSwzLjgxLTEuMyw3LjI2LTEuNzgsMTAuMXEtLjYzLDMuODYtMS4yNyw3LjQ3Yy0uMjIsMS4yMS0uNDQsMi40MS0uNjcsMy41OGExMTcsMTE3LDAsMCwxLTQsMTUuNzdIODIuODFWOTkuNzZhNzguNTgsNzguNTgsMCwwLDEtMzAuODIsMTQiLz48cGF0aCBjbGFzcz0iY2xzLTQiIGQ9Ik02LjUsMTA3LjIyYTIyOS44LDIyOS44LDAsMCwxLDE0LjYtNzJBMjI3LjM1LDIyNy4zNSwwLDAsMSwzOCwwSDBWMTA1LjhjMS44Ni40Nyw0LDEsNi41LDEuNDIiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xMzAuMzUsMjUuNTZIMTE0LjczVjM2LjcxbDMuMi4xNnY0LjdIMTA0LjU4VjM3LjFsMS44Mi0uMTdjLjk0LS4xMSwxLjYtLjQ0LDEuNi0xLjU1VjkuNzJsLTMuMTUtLjE2VjQuODZoMTMuMzZWOS4zM2wtMS44Mi4xN2MtMSwuMTEtMS42Ni40NC0xLjY2LDEuODJ2OC41NmgxNS42MlY5LjcybC0zLjE0LS4xNlY0Ljg2aDEzLjM1VjkuMzNsLTEuODIuMTdjLS45NC4xMS0xLjYuNDQtMS42LDEuNzdWMzYuNzFsMy4xNS4xNnY0LjdIMTI2LjkzVjM3LjFsMS44Mi0uMTdjMS4wNS0uMTEsMS42LS40NCwxLjYtMS44MloiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xNjAuMzIsNDIuMjhjLTkuODIsMC0xNi02LjQtMTYtMTksMC0xNC4xMyw4Ljg5LTE5LjEsMTYuNjItMTkuMSw4LjIyLDAsMTUuNjIsNS4wOCwxNS42MiwxOS4xQzE3Ni41NSwzNS45NCwxNzAsNDIuMjgsMTYwLjMyLDQyLjI4Wm0uMzktNS41N2M3LDAsOS02LjYyLDktMTMuMjUsMC01LjYzLTEuNDktMTMuNTctOS4xLTEzLjU3LTcuMDcsMC05LjM5LDYuNTYtOS4zOSwxMy4xM0MxNTEuMjEsMjkuMzEsMTUyLjc2LDM2LjcxLDE2MC43MSwzNi43MVoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xODAuNTIsMzcuMWwxLjgyLS4xN2MuOTQtLjExLDEuNi0uNDQsMS42LTEuNTVWOS43MmwtMy4xNC0uMTZWNC44NmgxNS43OGM4LjExLDAsMTMuMDgsMy44NywxMy4wOCwxMS4yNiwwLDguMzktNiwxMi41OS0xNC4yOSwxMi41OWgtNC43djhsNS4zLjE2djQuN0gxODAuNTJabTE0LjEzLTEzLjc1YzQuOCwwLDguMDYtMS42NSw4LjA2LTYuNTYsMC01LjY5LTMuMjYtNi41Ny04LjY3LTYuNTdoLTMuMzdWMjMuMzVaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjEzLjE5LDQxLjU3VjM3LjFsMS44Mi0uMTdjLjk0LS4xMSwxLjYtLjQ0LDEuNi0xLjU1VjkuNzJsLTMuMTQtLjE2VjQuODZoMjUuMjhWMTRsLTUuNjMuMzhWMTIuMmMwLTEtLjExLTEuNzEtMS42MS0xLjcxaC04LjE2djkuNDRIMjM2LjF2NS42M0gyMjMuMzVWMzUuODhoOC44OGMxLjQ0LDAsMS41NS0uNjYsMS41NS0xLjc2VjMxLjM2bDUuNjMuMzh2OS44M1oiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMTUuNDUsNjEuNiwxMTIsNjEuMjdWNTYuOGgxMi42NGwxMS4yNiwzMS44NGguMDZsMy4xNC4xN1Y5My41SDEyNC44M1Y4OWwyLjEtLjE3YzEuMTYtLjExLDEuNzEtLjQ0LDEuMzMtMS42NWwtMS4xNi0zLjQySDExNC4xOGwtMS42NSw0Ljg1LDMuMzEuMTdWOTMuNUgxMDMuMDlWODlsMS44Mi0uMTdjLjk0LS4xMSwxLjI3LS40OSwxLjY1LTEuNTRabS4wNiwxNy4xMWgxMC4yNmwtNS0xNS43M2gtLjE3WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE0MS4xMSw4OWwxLjgzLS4xN2MuOTMtLjExLDEuNi0uNDQsMS42LTEuNTRWNjEuNjZsLTMuMTUtLjE3VjU2LjhoMTUuMDdjOC4xMSwwLDEzLjI0LDIuNjUsMTMuMjQsMTAuMTVhMTAuMTYsMTAuMTYsMCwwLDEtNi42Miw5LjcyYzEuNDkuNTUsMi4zMiwxLjQ5LDMuMTUsMy4zNmw0LDguNjcsMy4xNS4xMVY5My41SDE1OS43MVY4OWwxLjYtLjE3YzEuMjctLjE2LDEuNTUtLjY2LDEuMDUtMS43NmwtMi41OS01LjUyQzE1OSw3OS44NywxNTguMjIsNzksMTU2LjI5LDc5aC01djkuNmwzLjU5LjE3VjkzLjVIMTQxLjExWm0xNS0xNS4yM2M0LjY5LDAsNi43OS0yLjE2LDYuNzktNi4wNywwLTUtMi44Ny01LjU4LTcuNTYtNS41OGgtNFY3My44WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE4NC4zMyw2Mi4yNkgxODBjLTEuMTYsMC0xLjI3Ljc3LTEuMjcsMS43MXYyLjZsLTUuNjMtLjM5VjU2LjhIMjAydjkuMzhsLTUuNjMuMzlWNjRjMC0xLS4xMS0xLjcxLTEuNi0xLjcxSDE5MVY4OC42NGw0LjM2LjE3VjkzLjVIMTc5LjhWODlsMi45My0uMTdjMS4wNS0uMTEsMS42LS40NCwxLjYtMS41NFoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMzAuMzYsNzcuNUgyMTQuNzRWODguNjRsMy4yLjE3VjkzLjVIMjA0LjU4Vjg5bDEuODItLjE3Yy45NC0uMTEsMS42LS40NCwxLjYtMS41NFY2MS42NmwtMy4xNC0uMTdWNTYuOGgxMy4zNXY0LjQ3bC0xLjgyLjE2Yy0xLC4xMS0xLjY1LjQ1LTEuNjUsMS44MnY4LjU2aDE1LjYyVjYxLjY2bC0zLjE1LS4xN1Y1Ni44aDEzLjM2djQuNDdsLTEuODIuMTZjLS45NC4xMS0xLjYxLjQ1LTEuNjEsMS43N1Y4OC42NGwzLjE1LjE3VjkzLjVIMjI2LjkzVjg5bDEuODMtLjE3YzEuMDUtLjExLDEuNi0uNDQsMS42LTEuODJaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjQzLjg4LDg5bDEuODItLjE3Yy45NC0uMTEsMS42LS40NCwxLjYtMS41NFY2MS42NmwtMy4xNS0uMTdWNTYuOGgxNS4wN2M4LjExLDAsMTMuMjUsMi42NSwxMy4yNSwxMC4xNWExMC4xNywxMC4xNywwLDAsMS02LjYzLDkuNzJjMS40OS41NSwyLjMyLDEuNDksMy4xNSwzLjM2bDQsOC42NywzLjE1LjExVjkzLjVIMjYyLjQ4Vjg5bDEuNi0uMTdjMS4yNy0uMTYsMS41NC0uNjYsMS4wNS0xLjc2bC0yLjYtNS41MkMyNjEuNzYsNzkuODcsMjYxLDc5LDI1OS4wNSw3OWgtNXY5LjZsMy41OS4xN1Y5My41SDI0My44OFpNMjU4LjgzLDczLjhjNC42OSwwLDYuNzktMi4xNiw2Ljc5LTYuMDcsMC01LTIuODctNS41OC03LjU2LTUuNThoLTRWNzMuOFoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yODEuODUsNjEuNjZsLTMuMTUtLjE3VjU2LjhoMTMuMzZ2NC40N2wtMS44Mi4xNmExLjU0LDEuNTQsMCwwLDAtMS42LDEuNzdWODguNjRsMy4xNC4xN1Y5My41SDI3OC40M1Y4OWwxLjgyLS4xN2MxLjA1LS4xMSwxLjYtLjQ0LDEuNi0xLjgyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTMwNS42Myw2Mi4yNmgtNC4zYy0xLjE2LDAtMS4yNy43Ny0xLjI3LDEuNzF2Mi42bC01LjYzLS4zOVY1Ni44SDMyMy4zdjkuMzhsLTUuNjMuMzlWNjRjMC0xLS4xMS0xLjcxLTEuNi0xLjcxaC0zLjc2Vjg4LjY0bDQuMzYuMTdWOTMuNUgzMDEuMTFWODlsMi45Mi0uMTdjMS4wNS0uMTEsMS42LS40NCwxLjYtMS41NFoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zMjkuMzEsNjEuNjZsLTMuMTQtLjE3VjU2LjhoMTMuMzV2NC40N2wtMS44Mi4xNmExLjU0LDEuNTQsMCwwLDAtMS42LDEuNzdWODguNjRsMy4xNS4xN1Y5My41SDMyNS44OVY4OWwxLjgyLS4xN2MxLjA1LS4xMSwxLjYtLjQ0LDEuNi0xLjgyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM2MSw4My4yM2MwLTMuNDctMy4xNS00LjQ3LTctNS41MUMzNDguNTIsNzYuMjMsMzQzLjQ0LDc0LDM0My40NCw2N2MwLTYuNzMsNS4xOS0xMC44MSwxMi44LTEwLjgxYTI0LDI0LDAsMCwxLDEwLjM4LDIuMjZ2OC4yOGwtNS42My4zOHYtMy4yYzAtMS0uMTctMS40OS0xLjE2LTEuODJhMTMuMDksMTMuMDksMCwwLDAtMy41OS0uNDRjLTMuMjUsMC01Ljc5LDEuMzItNS43OSw0Ljc1czMuMiw0LjM2LDcuMzQsNS42M2M1LDEuNiwxMC4zMiwzLjg2LDEwLjMyLDExLDAsNy4yOC01Ljc0LDExLjI2LTEzLjM2LDExLjI2QTI1LjEyLDI1LjEyLDAsMCwxLDM0My42LDkyVjgzLjIzbDUuNjMtLjM4djMuMzZjMCwxLjA1LjE3LDEuNSwxLjE2LDEuODNhMTQuMDUsMTQuMDUsMCwwLDAsNCwuNDlDMzU4LDg4LjUzLDM2MSw4Ny4zNywzNjEsODMuMjNaIi8+PHBhdGggY2xhc3M9ImNscy00IiBkPSJNMTA0LjY5LDE0MWwxLjgyLS4xNmMuOTQtLjExLDEuNi0uNDQsMS42LTEuNTVWMTEzLjU5bC0zLjE0LS4xN3YtNC42OWgyNi42NXY5LjE2bC01LjYzLjM5di0yLjIxYzAtMS0uMTEtMS43MS0xLjYtMS43MWgtOS41NXY5Ljc3aDEzLjU4djUuNjNIMTE0Ljg0djEwLjgybDQuOTIuMTZ2NC42OUgxMDQuNjlaIi8+PHBhdGggY2xhc3M9ImNscy00IiBkPSJNMTUxLDE0Ni4xNWMtOS44MiwwLTE2LTYuNC0xNi0xOSwwLTE0LjEzLDguODgtMTkuMSwxNi42MS0xOS4xLDguMjIsMCwxNS42Miw1LjA4LDE1LjYyLDE5LjFDMTY3LjIyLDEzOS44LDE2MC42NSwxNDYuMTUsMTUxLDE0Ni4xNVptLjM5LTUuNTdjNywwLDktNi42Miw5LTEzLjI1LDAtNS42My0xLjQ5LTEzLjU4LTkuMTEtMTMuNTgtNy4wNiwwLTkuMzgsNi41Ny05LjM4LDEzLjE0QzE0MS44OSwxMzMuMTgsMTQzLjQzLDE0MC41OCwxNTEuMzgsMTQwLjU4WiIvPjxwYXRoIGNsYXNzPSJjbHMtNCIgZD0iTTE4MCwxMzMuNTFjMCw1LjQxLDIuODIsNyw3LjIzLDdzNy4xOC0yLjIxLDcuMTgtNi43M3YtMjAuMmwtMy4yLS4xN3YtNC42OWgxMy4wOHY0LjQ3bC0xLjgyLjE3Yy0xLC4xMS0xLjYuNTUtMS42LDEuNjV2MTkuNzFjMCw3LjIzLTUuNDcsMTEuNDItMTMuODYsMTEuNDItOS4wNSwwLTEzLjY4LTMuNjQtMTMuNjgtMTIuMzFWMTEzLjU5bC0zLjIxLS4xN3YtNC42OUgxODMuNXY0LjQ3bC0xLjgyLjE3Yy0xLjA1LjExLTEuNjYuNDQtMS42NiwxLjgyWiIvPjxwYXRoIGNsYXNzPSJjbHMtNCIgZD0iTTIwNy4wNywxNDFsMi0uMTZjLjk0LS4wNiwxLjQ0LS40NCwxLjQ0LTEuNTVWMTEzLjU5bC0zLjE1LS4xN3YtNC42OWg5Ljk0bDE1LjYyLDI1LjM0SDIzM1YxMTMuNTlsLTMuNjUtLjE3di00LjY5aDEzLjQ3djQuNDdsLTIsLjE3Yy0uODMsMC0xLjMyLjU1LTEuMzIsMS43MXYzMC4zNWgtNi40NmwtMTUuOTUtMjUuNzFIMjE3djIwLjg2bDMuNTkuMTZ2NC42OUgyMDcuMDdaIi8+PHBhdGggY2xhc3M9ImNscy00IiBkPSJNMjQ2LjA5LDE0MWwxLjgyLS4xNmMuOTMtLjExLDEuNi0uNDQsMS42LTEuNTVWMTEzLjU5bC0zLjE1LS4xN3YtNC42OWgxNS4xMmMxMC41NCwwLDE3LjIyLDUuNTgsMTcuMjIsMTcuMDYsMCwxNC40Ni04LjA2LDE5LjY0LTE2Ljk0LDE5LjY0SDI0Ni4wOVptMTAuMTUtLjgyaDUuNjNjNi4xOCwwLDEwLTQuNTMsMTAtMTMuMzYsMC05LjkzLTQuOC0xMi42OS0xMC43Ni0xMi42OWgtNC45MVoiLz48cGF0aCBjbGFzcz0iY2xzLTQiIGQ9Ik0yOTMuNTUsMTEzLjUzbC0zLjQ4LS4zM3YtNC40N2gxMi42NEwzMTQsMTQwLjU4aDBsMy4xNS4xNnY0LjY5SDMwMi45M1YxNDFsMi4xLS4xNmMxLjE2LS4xMSwxLjcxLS40NCwxLjMyLTEuNjZsLTEuMTYtMy40MkgyOTIuMjhsLTEuNjYsNC44NiwzLjMxLjE2djQuNjlIMjgxLjE5VjE0MWwxLjgyLS4xNmMuOTMtLjExLDEuMjctLjUsMS42NS0xLjU1Wm0uMDUsMTcuMTFoMTAuMjdsLTUtMTUuNzNoLS4xNloiLz48cGF0aCBjbGFzcz0iY2xzLTQiIGQ9Ik0zMjUuNjcsMTE0LjJoLTQuMzFjLTEuMTYsMC0xLjI3Ljc3LTEuMjcsMS43MXYyLjU5bC01LjYyLS4zOHYtOS4zOWgyOC44NnY5LjM5bC01LjYzLjM4di0yLjU5YzAtMS0uMTEtMS43MS0xLjYtMS43MWgtMy43NXYyNi4zOGw0LjM2LjE2djQuNjlIMzIxLjE0VjE0MWwyLjkzLS4xNmMxLjA1LS4xMSwxLjYtLjQ0LDEuNi0xLjU1WiIvPjxwYXRoIGNsYXNzPSJjbHMtNCIgZD0iTTM0OS4zNSwxMTMuNTlsLTMuMTUtLjE3di00LjY5aDEzLjM2djQuNDdsLTEuODMuMTdjLS45My4xMS0xLjYuNDQtMS42LDEuNzZ2MjUuNDVsMy4xNS4xNnY0LjY5SDM0NS45MlYxNDFsMS44My0uMTZjMS0uMTEsMS42LS40NCwxLjYtMS44MloiLz48cGF0aCBjbGFzcz0iY2xzLTQiIGQ9Ik0zNzkuMzEsMTQ2LjE1Yy05LjgyLDAtMTYtNi40LTE2LTE5LDAtMTQuMTMsOC44OC0xOS4xLDE2LjYxLTE5LjEsOC4yMiwwLDE1LjYyLDUuMDgsMTUuNjIsMTkuMUMzOTUuNTQsMTM5LjgsMzg5LDE0Ni4xNSwzNzkuMzEsMTQ2LjE1Wm0uMzktNS41N2M3LDAsOS02LjYyLDktMTMuMjUsMC01LjYzLTEuNDktMTMuNTgtOS4xMS0xMy41OC03LjA3LDAtOS4zOCw2LjU3LTkuMzgsMTMuMTRDMzcwLjIxLDEzMy4xOCwzNzEuNzUsMTQwLjU4LDM3OS43LDE0MC41OFoiLz48cGF0aCBjbGFzcz0iY2xzLTQiIGQ9Ik0zOTkuNTEsMTQxbDItLjE2Yy45NC0uMDYsMS40My0uNDQsMS40My0xLjU1VjExMy41OWwtMy4xNC0uMTd2LTQuNjloOS45M2wxNS42MiwyNS4zNGguMTFWMTEzLjU5bC0zLjY0LS4xN3YtNC42OWgxMy40N3Y0LjQ3bC0yLC4xN2MtLjgzLDAtMS4zMi41NS0xLjMyLDEuNzF2MzAuMzVoLTYuNDZsLTE1Ljk1LTI1LjcxaC0uMTF2MjAuODZsMy41OC4xNnY0LjY5SDM5OS41MVoiLz48L2c+PC9nPjwvc3ZnPg==",
  logoPosition: "right",
  completedHtmlOnCondition: [
    {
      html: {
        default:
          "Thanks for your feedback! We highly value all ideas and suggestions from our customers, whether they're positive or critical. In the future, our team might reach out to you to learn more about how we can further improve our product so that it exceeds your expectations.",
        fr: "Merci pour vos commentaires! Nous accordons une grande importance à toutes les idées et suggestions de nos clients, qu'elles soient positives ou critiques. À l'avenir, notre équipe pourrait vous contacter pour en savoir plus sur la façon dont nous pouvons encore améliorer notre produit afin qu'il dépasse vos attentes.",
      },
    },
    {
      html: {
        default:
          "Thanks for your feedback. Our goal is to create the best possible product, and your thoughts, ideas, and suggestions play a major role in helping us identify opportunities to improve.",
        fr: "Merci pour vos commentaires. Notre objectif est de créer le meilleur produit possible, et vos réflexions, idées et suggestions jouent un rôle majeur pour nous aider à identifier les opportunités d'amélioration.",
      },
    },
    {
      html: {
        default:
          "Thanks for your feedback. It's great to hear that you're a fan of our product. Your feedback helps us discover new opportunities to improve it and make sure you have the best possible experience.",
        fr: "Merci pour vos commentaires. Nous sommes ravis d'entendre que vous avez apprécié notre produit. Vos commentaires nous aident à découvrir de nouvelles opportunités pour l'améliorer et vous assurer la meilleure expérience possible.",
      },
    },
  ],
  pages: [
    {
      name: "page1",
      elements: [
        {
          type: "checkbox",
          name: "question1",
          title: "I am a?",
          isRequired: true,
          choices: [
            {
              value: "parent",
              text: "A Parent of a child with a rheumatic disease",
            },
            {
              value: "relative",
              text: "A Relative of a child with a rheumatic disease",
            },
            {
              value: "guardian",
              text: "A Guardian of a child with a rheumatic disease",
            },
          ],
          showOtherItem: true,
        },
      ],
      title: "A. TELL US ABOUT YOURSELF",
    },
    {
      name: "page2",
      elements: [
        {
          type: "checkbox",
          name: "question2",
          title: "What condition does the child you are concerned about have?",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Juvenile Idiopathic Arthritis (JIA)",
            },
            {
              value: "Item 2",
              text: "Juvenile Dermatomyositis (JDM)",
            },
            {
              value: "Item 3",
              text: "Scleroderma",
            },
            {
              value: "Item 4",
              text: "Sarcoidosis",
            },
            {
              value: "Item 5",
              text: "Benign joint hypermobility",
            },
            {
              value: "Item 6",
              text: "Systemic Lupus Erythematosus",
            },
            {
              value: "Item 7",
              text: "Vasculitis",
            },
            {
              value: "Item 8",
              text: "Sjogren’s",
            },
            {
              value: "Item 9",
              text: "Auto-inflammatory disease",
            },
            {
              value: "Item 10",
              text: "Flat feet",
            },
          ],
          showOtherItem: true,
          showNoneItem: true,
          noneText: "I do not know",
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "question3",
          title:
            "During the first year after the child was diagnosed with the paediatric rheumatic disease, what\nwere some challenging situations you your family and friends experienced?",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Confusion",
            },
            {
              value: "Item 2",
              text: "Anger",
            },
            {
              value: "Item 3",
              text: "Stigma",
            },
            {
              value: "Item 4",
              text: "Lack of resources for hospital visits",
            },
            {
              value: "Item 5",
              text: "Expensive tests",
            },
            {
              value: "Item 6",
              text: "Expensive medications",
            },
          ],
          showOtherItem: true,
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "question4",
          title:
            "How did the situation (or these situations) affect you/your partner/your child with JIA/your other\nchild(ren)/the relationships between family members?",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "It led to family unity",
            },
            {
              value: "Item 2",
              text: "It led to family conflict",
            },
            {
              value: "Item 3",
              text: "I felt that I did not give other family members enough attention",
            },
            {
              value: "Item 4",
              text: "I blamed myself for everything",
            },
            {
              value: "Item 5",
              text: "I was depressed",
            },
          ],
          showOtherItem: true,
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "question5",
          title:
            "What are the things that you have been doing to manage this challenging situation (or these\nchallenging situations)?",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Scanning the internet for more information",
            },
            {
              value: "Item 2",
              text: "Reaching out to families in similar circumstances",
            },
            {
              value: "Item 3",
              text: "Seeking counselling",
            },
            {
              value: "Item 4",
              text: "Taking time off work",
            },
            {
              value: "Item 5",
              text: "Seeking spiritual intervention eg prayer",
            },
          ],
          showOtherItem: true,
          colCount: 2,
        },
        {
          type: "comment",
          name: "question6",
          title: "Any other thoughts you would like to share with us?",
        },
      ],
      title: "SHARING YOUR EXPERIENCE WITH PAEDIATRIC RHEUMATOLOGY",
    },
  ],
  showPrevButton: false,
  showQuestionNumbers: "off",
  completeText: {
    fr: "Envoyer",
    default: "Submit Survey",
  },
  widthMode: "responsive",
  width: "1000px",
};

export const healthWorkerJson = {
  title: "HEALTH WORKER INTRODUCTORY SURVEY",
  logo: "data:image/svg+xml;base64,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",
  completedHtmlOnCondition: [
    {
      html: {
        default:
          "Thanks for your feedback! We highly value all ideas and suggestions from our customers, whether they're positive or critical. In the future, our team might reach out to you to learn more about how we can further improve our product so that it exceeds your expectations.",
        fr: "Merci pour vos commentaires! Nous accordons une grande importance à toutes les idées et suggestions de nos clients, qu'elles soient positives ou critiques. À l'avenir, notre équipe pourrait vous contacter pour en savoir plus sur la façon dont nous pouvons encore améliorer notre produit afin qu'il dépasse vos attentes.",
      },
    },
    {
      html: {
        default:
          "Thanks for your feedback. Our goal is to create the best possible product, and your thoughts, ideas, and suggestions play a major role in helping us identify opportunities to improve.",
        fr: "Merci pour vos commentaires. Notre objectif est de créer le meilleur produit possible, et vos réflexions, idées et suggestions jouent un rôle majeur pour nous aider à identifier les opportunités d'amélioration.",
      },
    },
    {
      html: {
        default:
          "Thanks for your feedback. It's great to hear that you're a fan of our product. Your feedback helps us discover new opportunities to improve it and make sure you have the best possible experience.",
        fr: "Merci pour vos commentaires. Nous sommes ravis d'entendre que vous avez apprécié notre produit. Vos commentaires nous aident à découvrir de nouvelles opportunités pour l'améliorer et vous assurer la meilleure expérience possible.",
      },
    },
  ],
  pages: [
    {
      name: "page1",
      elements: [
        {
          type: "checkbox",
          name: "question1",
          title: "Qualification",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "MBCHB",
            },
            {
              value: "Item 2",
              text: "MD",
            },
            {
              value: "Item 3",
              text: "MMed",
            },
            {
              value: "Item 4",
              text: "MPhil",
            },
            {
              value: "Item 5",
              text: "PHD",
            },
          ],
          showOtherItem: true,
          otherText: "Other",
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "question2",
          title: "Job Role",
          isRequired: true,
          choices: [
            {
              value: "Item ",
              text: "Paediatric rheumatologist",
            },
            {
              value: "Item 2",
              text: "Adult rheumatologist",
            },
            {
              value: "Item 3",
              text: "General paediatrician",
            },
            {
              value: "Item 4",
              text: "General practitioner",
            },
            {
              value: "Item 5",
              text: "Allied health professional please specify (e.g. nurse, physiotherapist, occupational therapist)",
            },
          ],
          showOtherItem: true,
          otherText: "Other specialists (specify)",
          colCount: 2,
        },
        {
          type: "text",
          name: "question3",
          visible: false,
          visibleIf: "{question2} allof ['Item 5']",
          title: "Health Professional Specification",
          isRequired: true,
        },
        {
          type: "checkbox",
          name: "question4",
          title: "I practice in (select all that apply)",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "An academic centre/ teaching hospital",
            },
            {
              value: "Item 2",
              text: "Private clinical practice",
            },
            {
              value: "Item 3",
              text: "Government funded (public sector) clinical practice",
            },
            {
              value: "Item 4",
              text: "A mix of state-run/government funded and private practice",
            },
          ],
          showOtherItem: true,
          otherText: "Other",
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "question5",
          title: "Numbers of years I have been in practice (years)",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "<5",
            },
            {
              value: "Item 2",
              text: "5-10",
            },
            {
              value: "Item 3",
              text: "10-15",
            },
            {
              value: "Item 4",
              text: "15-20",
            },
            {
              value: "Item 5",
              text: "20-30",
            },
            {
              value: "Item 6",
              text: "30-40",
            },
            {
              value: "Item 7",
              text: "40+",
            },
          ],
          colCount: 2,
          maxSelectedChoices: 1,
        },
        {
          type: "checkbox",
          name: "question6",
          title:
            "In relation to my postgraduate paediatric rheumatology training",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "This was in my home country",
            },
            {
              value: "Item 2",
              text: "This was in a combination of my home country and another country",
            },
            {
              value: "Item 3",
              text: "I have not had any postgraduate training in paediatric rheumatology",
            },
          ],
          showOtherItem: true,
          otherText: "This was in another country (please specify)",
        },
      ],
      title: "A. TELL US ABOUT YOURSELF",
    },
    {
      name: "page2",
      elements: [
        {
          type: "checkbox",
          name: "question7",
          title:
            "In my country, children with rheumatic disease are in the mainly under the care of: (please tick most\nrelevant)",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "General paediatricians",
            },
            {
              value: "Item 2",
              text: "General practitioners",
            },
            {
              value: "Item 3",
              text: "Adult rheumatologists",
            },
            {
              value: "Item 4",
              text: "Paediatric rheumatologists",
            },
            {
              value: "Item 5",
              text: "Allergists / immunologists",
            },
            {
              value: "Item 6",
              text: "Nurses",
            },
            {
              value: "Item 7",
              text: "Community Health workers",
            },
          ],
          showOtherItem: true,
          showNoneItem: true,
          noneText: "Not applicable",
          otherText: "Other (specify)",
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "question8",
          title:
            "Drugs available for the treatment of childhood rheumatic disease in your health facility includes\n(select all that apply)",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Non Steroidal Anti-inflammatory drugs (NSAIDs eg ibuprofen)",
            },
            {
              value: "Item 2",
              text: "Cyclosporine/ ciclosporin",
            },
            {
              value: "Item 3",
              text: "Methotrexate",
            },
            {
              value: "Item 4",
              text: "Cyclophosphamide",
            },
            {
              value: "Item 5",
              text: "Sulfasalazine",
            },
            {
              value: "Item 6",
              text: "Leflunomide",
            },
            {
              value: "Item 7",
              text: "Gold",
            },
            {
              value: "Item 8",
              text: "Penicillamine",
            },
            {
              value: "Item 9",
              text: "Hydroxychloroquine",
            },
            {
              value: "Item 10",
              text: "Azathioprine",
            },
            {
              value: "Item 11",
              text: "Oral corticosteroids",
            },
            {
              value: "Item 12",
              text: "Parenteral corticosteroids",
            },
            {
              value: "Item 13",
              text: "Triamcinolone Hexacetonide (Intra-articular corticosteroid)",
            },
            {
              value: "Item 14",
              text: "Triamcinolone Acetonide (Intra-articular corticosteroid)",
            },
            {
              value: "Item 15",
              text: "Mycophenolate Mofetil",
            },
            {
              value: "Item 16",
              text: "Cyclosporine",
            },
            {
              value: "Item 17",
              text: "Tacrolimus",
            },
          ],
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "question9",
          title:
            "Biologicals available include (please specify which ones of the following list):",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Adalimumab",
            },
            {
              value: "Item 2",
              text: "Etanercept",
            },
            {
              value: "Item 3",
              text: "Infliximab",
            },
            {
              value: "Item 4",
              text: "Rituximab",
            },
            {
              value: "Item 5",
              text: "Anakinra",
            },
            {
              value: "Item 6",
              text: "Tocilizumab",
            },
            {
              value: "Item 7",
              text: "Golimumab",
            },
            {
              value: "Item 8",
              text: "Tofacitinib",
            },
            {
              value: "Item 9",
              text: "Abatacept",
            },
            {
              value: "Item 10",
              text: "Ustekinumab",
            },
          ],
          showOtherItem: true,
          otherText: "Other biologicals (please specify)",
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "question10",
          title:
            "Barriers to providing a specialised multidisciplinary paediatric rheumatology service in your health\nfacility include (select all that apply)",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Absence / inadequate provision of specialists",
            },
            {
              value: "Item 2",
              text: "Absence / inadequate provision of allied health professionals",
            },
            {
              value: "Item 3",
              text: "Busy clinical practice with inadequate time for paediatric rheumatology",
            },
            {
              value: "Item 4",
              text: "Absence / inadequate referral pathways into the service from other specialists or centres",
            },
            {
              value: "Item 5",
              text: "Absence of recognised centres for patient care",
            },
            {
              value: "Item 6",
              text: "Geographical distance",
            },
            {
              value: "Item 7",
              text: "Financial (please specify)",
            },
            {
              value: "Item 8",
              text: "Cultural (please specify):",
            },
            {
              value: "Item 9",
              text: "There are no barriers to accessing specialised care in my setting",
            },
          ],
          showOtherItem: true,
          otherText: "Other (specify)",
          colCount: 2,
        },
        {
          type: "text",
          name: "question11",
          visible: false,
          visibleIf: "{question10} allof ['Item 7']",
          title: "Financial Barrier",
          isRequired: true,
        },
        {
          type: "text",
          name: "question12",
          visible: false,
          visibleIf: "{question10} allof ['Item 8']",
          title: "Cultural Barrier",
          isRequired: true,
        },
      ],
      title: "B. CLINICAL CARE SERVICES",
    },
    {
      name: "page3",
      elements: [
        {
          type: "checkbox",
          name: "question13",
          title:
            "The following are barriers to paediatric rheumatology training in my health facility (select all that\napply):",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "No structured paediatric rheumatology training programme",
            },
            {
              value: "Item 2",
              text: "Lack of funding for paediatric rheumatology training",
            },
            {
              value: "Item 3",
              text: "Lack of interested applicants to a programme",
            },
            {
              value: "Item 4",
              text: "Increased interest for training/higher priority in resources allotment in other specialties reflecting higher burden of other diseases e.g infectious disease",
            },
            {
              value: "Item 5",
              text: "Lack of a critical mass of trained paediatric rheumatologists to supervise trainees",
            },
            {
              value: "Item 6",
              text: "Patient volume (not enough patients) to justify training programmes",
            },
            {
              value: "Item 7",
              text: "No positions/ jobs once training is completed",
            },
            {
              value: "Item 8",
              text: "No recognition of the subspecialty by professional associations or government",
            },
          ],
          showOtherItem: true,
          otherText: "Other (specify)",
          colCount: 2,
        },
      ],
      title: "C. PAEDIATRIC RHEUMATOLOGY TRAINING",
    },
    {
      name: "page4",
      elements: [
        {
          type: "checkbox",
          name: "question14",
          title:
            "In your opinion, what are the main challenges /factor(s) affecting the clinical care for children and\nyoung people with rheumatic diseases in your health facility? (select all that may apply)",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "Socioeconomic barriers eg lack of finances",
            },
            {
              value: "Item 2",
              text: "Comorbidities (e.g. infection burden)",
            },
            {
              value: "Item 3",
              text: "Poor/delayed access to the health system",
            },
            {
              value: "Item 4",
              text: "Cultural issues impacting adherence to appropriate therapy (e.g. medicines, physical therapy)",
            },
            {
              value: "Item 5",
              text: "Poor access to medicines",
            },
            {
              value: "Item 6",
              text: "Poor access to rehabilitation services eg physiotherapy, occupational therapy",
            },
            {
              value: "Item 7",
              text: "Poor access to hospital-based services",
            },
            {
              value: "Item 8",
              text: "Poor transitional care to adult rheumatology",
            },
          ],
          showOtherItem: true,
          otherText: "Other (specify)",
          colCount: 2,
        },
        {
          type: "checkbox",
          name: "question15",
          title:
            "What do you think would make a difference (in a helpful way) to the way that you can deliver\nclinical care in your health facility? (select all that may apply)",
          isRequired: true,
          choices: [
            {
              value: "Item 1",
              text: "More specialists (in paediatric rheumatology)",
            },
            {
              value: "Item 2",
              text: "More specialist nurses (in paediatric rheumatology)",
            },
            {
              value: "Item 3",
              text: "More specialist therapists (in paediatric rheumatology)",
            },
            {
              value: "Item 4",
              text: "More training programmes (in paediatric rheumatology)",
            },
            {
              value: "Item 5",
              text: "More paediatric musculoskeletal training programmes for paediatricians and family medicine doctors",
            },
            {
              value: "Item 6",
              text: "Continuing Medical Education programmes to improve and maintain knowledge",
            },
            {
              value: "Item 7",
              text: "Availability of online or e-learning activities",
            },
            {
              value: "Item 8",
              text: "Availability of specialist opinion through information technologies (e.g. tele-health, apps) to support clinical care and training",
            },
            {
              value: "Item 9",
              text: "Improved access to and affordability of medicines",
            },
            {
              value: "Item 10",
              text: "National guidelines and recommendations relevant to my setting",
            },
            {
              value: "Item 11",
              text: "Clearer pathways of care relevant to my setting",
            },
            {
              value: "Item 12",
              text: "More research to inform clinical care in my setting",
            },
            {
              value: "Item 13",
              text: "More clinical trials of medicines used in my clinical setting",
            },
            {
              value: "Item 14",
              text: "Patient advocacy groups",
            },
            {
              value: "Item 15",
              text: "Improved awareness amongst policy makers and politicians",
            },
          ],
          showOtherItem: true,
        },
      ],
      title: "D. FUTURE DIRECTIONS",
    },
  ],
  showPrevButton: false,
  showQuestionNumbers: "off",
  completeText: {
    fr: "Envoyer",
    default: "Submit Survey",
  },
  widthMode: "static",
  width: "1000px",
};

export const healthInstitutionJson = {
    "title": "HEALTH INSTITUTION INTRODUCTORY SURVEY",
    "logo": "data:image/svg+xml;base64,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",
    "completedHtmlOnCondition": [
     {
      "html": {
       "default": "Thanks for your feedback! We highly value all ideas and suggestions from our customers, whether they're positive or critical. In the future, our team might reach out to you to learn more about how we can further improve our product so that it exceeds your expectations.",
       "fr": "Merci pour vos commentaires! Nous accordons une grande importance à toutes les idées et suggestions de nos clients, qu'elles soient positives ou critiques. À l'avenir, notre équipe pourrait vous contacter pour en savoir plus sur la façon dont nous pouvons encore améliorer notre produit afin qu'il dépasse vos attentes."
      }
     },
     {
      "html": {
       "default": "Thanks for your feedback. Our goal is to create the best possible product, and your thoughts, ideas, and suggestions play a major role in helping us identify opportunities to improve.",
       "fr": "Merci pour vos commentaires. Notre objectif est de créer le meilleur produit possible, et vos réflexions, idées et suggestions jouent un rôle majeur pour nous aider à identifier les opportunités d'amélioration."
      }
     },
     {
      "html": {
       "default": "Thanks for your feedback. It's great to hear that you're a fan of our product. Your feedback helps us discover new opportunities to improve it and make sure you have the best possible experience.",
       "fr": "Merci pour vos commentaires. Nous sommes ravis d'entendre que vous avez apprécié notre produit. Vos commentaires nous aident à découvrir de nouvelles opportunités pour l'améliorer et vous assurer la meilleure expérience possible."
      }
     }
    ],
    "pages": [
     {
      "name": "page1",
      "elements": [
       {
        "type": "boolean",
        "name": "question1",
        "title": "I look after children with suspected or known rheumatic diseases in my setting",
        "isRequired": true
       }
      ],
      "title": "A. TELL US A LITTLE ABOUT YOU AS A RESPONDER TO THE SURVEY"
     },
     {
      "name": "page2",
      "elements": [
       {
        "type": "checkbox",
        "name": "question2",
        "title": "The main barriers to prompt and correct diagnosis of patients with rheumatic disease in our\nsetting are (select all that apply)",
        "isRequired": true,
        "choices": [
         {
          "value": "Item 1",
          "text": "Complex referral pathways which include professionals who may have limited knowledge of rheumatic diseases"
         },
         {
          "value": "Item 2",
          "text": "Lack of awareness of paediatric rheumatic diseases amongst health professionals"
         },
         {
          "value": "Item 3",
          "text": "Lack of awareness of paediatric rheumatic diseases within the general public population"
         },
         {
          "value": "Item 4",
          "text": "Social and cultural beliefs amongst the general population influencing their presentation healthcare"
         },
         {
          "value": "Item 5",
          "text": "Insufficient training about rheumatic diseases amongst paediatricians and other health professionals who may see children with suspected rheumatic disease"
         },
         {
          "value": "Item 6",
          "text": "Lack of specialist paediatric rheumatologist"
         },
         {
          "value": "Item 7",
          "text": "Lack of paediatric rheumatology teams (i.e. doctor, nurse, physiotherapist)"
         },
         {
          "value": "Item 8",
          "text": "Lack of access to available international or national guidelines to guide practice"
         },
         {
          "value": "Item 9",
          "text": "Lack of a patient/ family advocacy group/organisations to help raise awareness"
         },
         {
          "value": "Item 10",
          "text": "Lack of government support to fund clinical services and treatments"
         }
        ],
        "showOtherItem": true,
        "showNoneItem": true,
        "noneText": "Not applicable",
        "otherText": "Other barriers (please specify)",
        "colCount": 2
       },
       {
        "type": "checkbox",
        "name": "question3",
        "title": "In our centre, children with rheumatic disease are in the main, cared for by: (please tick most\nrelevant)",
        "isRequired": true,
        "choices": [
         {
          "value": "Item 1",
          "text": "General paediatricians"
         },
         {
          "value": "Item 2",
          "text": "General practitioners"
         },
         {
          "value": "Item 3",
          "text": "Adult rheumatologists"
         },
         {
          "value": "Item 4",
          "text": "Paediatric rheumatologists"
         },
         {
          "value": "Item 5",
          "text": "Allergists / immunologists"
         }
        ],
        "showOtherItem": true,
        "showNoneItem": true,
        "noneText": "Not applicable",
        "otherText": "Other (specify)",
        "colCount": 2
       },
       {
        "type": "checkbox",
        "name": "question4",
        "title": "The usual team members who care for paediatric rheumatology patients in my setting include the\nfollowing (select all that apply)",
        "isRequired": true,
        "choices": [
         {
          "value": "Item 1",
          "text": "General paediatricians"
         },
         {
          "value": "Item 2",
          "text": "Specialised rheumatology nurse(s)"
         },
         {
          "value": "Item 3",
          "text": "Paediatric rheumatologist(s)"
         },
         {
          "value": "Item 4",
          "text": "Physical therapist(s)"
         },
         {
          "value": "Item 5",
          "text": "Occupational therapist(s)"
         },
         {
          "value": "Item 6",
          "text": "Adult rheumatologist(s)"
         },
         "Item 7",
         "Item 8"
        ],
        "showOtherItem": true,
        "showNoneItem": true,
        "noneText": "Not applicable",
        "otherText": "Other (please specify)",
        "colCount": 2
       },
       {
        "type": "checkbox",
        "name": "question5",
        "title": "Drugs available for the treatment of childhood rheumatic disease in our centre are (select all that\napply)",
        "isRequired": true,
        "choices": [
         {
          "value": "Item 1",
          "text": "NSAIDs"
         },
         {
          "value": "Item 2",
          "text": "Methotrexate"
         },
         {
          "value": "Item 3",
          "text": "Sulfasalazine"
         },
         {
          "value": "Item 4",
          "text": "Gold"
         },
         {
          "value": "Item 5",
          "text": "Hydroxychloroquine"
         },
         {
          "value": "Item 6",
          "text": "Oral corticosteroids"
         },
         {
          "value": "Item 7",
          "text": "Parenteral corticosteroids"
         },
         {
          "value": "Item 8",
          "text": "Cyclosporine/ ciclosporin"
         },
         {
          "value": "Item 9",
          "text": "Cyclophosphamide"
         },
         {
          "value": "Item 10",
          "text": "Leflunomide"
         },
         {
          "value": "Item 11",
          "text": "Penicillamine"
         },
         {
          "value": "Item 12",
          "text": "Azathioprine"
         },
         {
          "value": "Item 13",
          "text": "Triamcinolone Hexacetonide (Intra-articular corticosteroid)"
         },
         {
          "value": "Item 14",
          "text": "Triamcinolone Acetonide (Intra-articular corticosteroid)"
         }
        ],
        "colCount": 2
       },
       {
        "type": "checkbox",
        "name": "question6",
        "title": "Biologicals (please specify which ones of the following list)",
        "isRequired": true,
        "choices": [
         {
          "value": "Item 1",
          "text": "Adalimumab"
         },
         {
          "value": "Item 2",
          "text": "Infliximab"
         },
         {
          "value": "Item 3",
          "text": "Etanercept"
         },
         {
          "value": "Item 4",
          "text": "Rituximab"
         },
         {
          "value": "Item 5",
          "text": "Anakinra"
         }
        ],
        "showOtherItem": true,
        "otherText": "Other biologicals (please specify)",
        "colCount": 2
       },
       {
        "type": "boolean",
        "name": "question7",
        "title": "Biosimilars (if yes, please specify which ones)",
        "isRequired": true
       },
       {
        "type": "text",
        "name": "question8",
        "visible": false,
        "visibleIf": "{question7} = true",
        "title": "Biosimilars ",
        "isRequired": true
       },
       {
        "type": "checkbox",
        "name": "question9",
        "title": "Barriers to providing a specialised multidisciplinary paediatric rheumatology service in our\nsetting include (select all that apply)",
        "isRequired": true,
        "choices": [
         {
          "value": "Item 1",
          "text": "Absence / inadequate provision of specialists"
         },
         {
          "value": "Item 2",
          "text": "Absence / inadequate provision of allied health professionals"
         },
         {
          "value": "Item 3",
          "text": "Need to focus on high workload in other areas of my clinical practice with inadequate time for paediatric rheumatology"
         },
         {
          "value": "Item 4",
          "text": "Absence / inadequate referral pathways into the service from other specialists or centres"
         },
         {
          "value": "Item 5",
          "text": "Absence of recognised centres for patient care"
         },
         {
          "value": "Item 6",
          "text": "Geographical"
         },
         {
          "value": "Item 7",
          "text": "Financial (please specify)"
         },
         {
          "value": "Item 8",
          "text": "Cultural (please specify)"
         }
        ],
        "showNoneItem": true,
        "noneText": "There are no barriers to accessing specialised care in my setting",
        "colCount": 2
       },
       {
        "type": "text",
        "name": "question10",
        "visible": false,
        "visibleIf": "{question9} allof ['Item 7']",
        "title": "Financial Barriers",
        "isRequired": true
       },
       {
        "type": "text",
        "name": "question11",
        "visibleIf": "{question9} allof ['Item 8']",
        "title": "Cultural Barriers",
        "isRequired": true
       }
      ],
      "visibleIf": "{question1} = true",
      "title": "B. AWARENESS AND CLINICAL CARE DELIVERY"
     },
     {
      "name": "page3",
      "elements": [
       {
        "type": "checkbox",
        "name": "question12",
        "title": "The following are barriers to paediatric rheumatology training in my country (select all that\napply)",
        "isRequired": true,
        "choices": [
         {
          "value": "Item 1",
          "text": "No structured paediatric rheumatology training programme"
         },
         {
          "value": "Item 2",
          "text": "Lack of funding for paediatric rheumatology training positions"
         },
         {
          "value": "Item 3",
          "text": "Lack of interested applicants to a programme"
         },
         {
          "value": "Item 4",
          "text": "Increased interest for training/ higher priority in resources allotment in other specialties reflecting higher burden of other diseases e.g. infectious disease"
         },
         {
          "value": "Item 5",
          "text": "Lack of a critical mass of trained paediatric rheumatologists to supervise trainees"
         },
         {
          "value": "Item 6",
          "text": "Patient volume (not enough patients) to justify training programmes"
         },
         {
          "value": "Item 7",
          "text": "No positions/ jobs once training is completed"
         },
         {
          "value": "Item 8",
          "text": "No recognition of the subspecialty by professional associations or government"
         }
        ],
        "showOtherItem": true,
        "otherText": "Other (please specify)",
        "colCount": 2
       }
      ],
      "visibleIf": "{question1} = true",
      "title": "C. PAEDIATRIC RHEUMATOLOGY TRAINING"
     },
     {
      "name": "page4",
      "elements": [
       {
        "type": "checkbox",
        "name": "question13",
        "title": "In your opinion, what are the main challenges /factor(s) affecting the clinical care for children\nand young people with rheumatic diseases in your setting? (select all that may apply)",
        "isRequired": true,
        "choices": [
         {
          "value": "Item 1",
          "text": "Socioeconomic/ poverty"
         },
         {
          "value": "Item 2",
          "text": "Comorbidities (e.g. infection burden)"
         },
         {
          "value": "Item 3",
          "text": "Poor/delayed access to the health system"
         },
         {
          "value": "Item 4",
          "text": "Cultural issues impacting adherence to appropriate therapy (e.g. medicines, physical therapy)"
         },
         {
          "value": "Item 5",
          "text": "Poor access to medicines"
         },
         {
          "value": "Item 6",
          "text": "Poor access to physical therapy"
         },
         {
          "value": "Item 7",
          "text": "Poor access to hospital-based services"
         },
         {
          "value": "Item 8",
          "text": "Poor transitional care to adult rheumatology"
         }
        ],
        "showOtherItem": true,
        "otherText": "Other (specify)",
        "colCount": 2
       },
       {
        "type": "checkbox",
        "name": "question14",
        "title": "What do you think would make a difference (in a helpful way) to the way that you can deliver\nclinical care in your setting? (select all that may apply)",
        "isRequired": true,
        "choices": [
         {
          "value": "Item 1",
          "text": "More specialists (in paediatric rheumatology)"
         },
         {
          "value": "Item 2",
          "text": "More specialist nurses (in paediatric rheumatology)"
         },
         {
          "value": "Item 3",
          "text": "More specialist therapists (in paediatric rheumatology)"
         },
         {
          "value": "Item 4",
          "text": "More training programmes (in paediatric rheumatology)"
         },
         {
          "value": "Item 5",
          "text": "More paediatric musculoskeletal training programmes for paediatricians and family medicine doctors"
         },
         {
          "value": "Item 6",
          "text": "Continuing Medical Education programmes to improve and maintain knowledge"
         },
         {
          "value": "Item 7",
          "text": "Availability of online or e-learning activities"
         },
         {
          "value": "Item 8",
          "text": "Availability of specialist opinion through information technologies (e.g. tele-health)"
         },
         {
          "value": "Item 9",
          "text": "Improved access to and affordability of medicines (e.g. biologicals)"
         },
         {
          "value": "Item 10",
          "text": "Greater use of information technology (IT) (e.g. apps, tele-health and e-learning) to support clinical care and training"
         },
         {
          "value": "Item 11",
          "text": "National guidelines and recommendations relevant to my setting"
         },
         {
          "value": "Item 12",
          "text": "Clearer pathways of care relevant to my setting"
         },
         {
          "value": "Item 13",
          "text": "More research to inform clinical care in my setting"
         },
         {
          "value": "Item 14",
          "text": "More clinical trials of medicines used in my clinical setting"
         },
         {
          "value": "Item 15",
          "text": "Patient advocacy groups"
         },
         {
          "value": "Item 16",
          "text": "Improved awareness amongst policy makers and politicians"
         }
        ],
        "showOtherItem": true,
        "otherText": "Other (please describe)",
        "colCount": 2
       },
       {
        "type": "text",
        "name": "question15",
        "title": "Please add any other comments or feedback",
        "isRequired": true
       },
       {
        "type": "boolean",
        "name": "question16",
        "title": "Do you have a database of patients in your clinical practice?",
        "isRequired": true
       },
       {
        "type": "checkbox",
        "name": "question18",
        "title": "Would you like to discuss collaborative research in the future? (be open to us contacting you in\nthe future to discuss collaborative research)?",
        "isRequired": true,
        "choices": [
         {
          "value": "Item 1",
          "text": "Yes"
         },
         {
          "value": "Item 2",
          "text": "No"
         }
        ],
        "showNoneItem": true,
        "noneText": "Not applicable"
       },
       {
        "type": "boolean",
        "name": "question17",
        "title": "Thank you for your time to complete this questionnaire. If you would like to receive a copy of\nthe summary of the final report, please let us know"
       }
      ],
      "title": "D. MOVING FORWARDS"
     }
    ],
    "showPrevButton": false,
    "showQuestionNumbers": "off",
    "completeText": {
     "fr": "Envoyer"
    },
    "widthMode": "static",
    "width": "1000px"
   }


